import c3 from 'c3';
import { Subject, from } from 'rxjs';
import * as moment from 'moment-timezone';
import merge from 'lodash-es/merge';
import isArray from 'lodash-es/isArray';
import difference from 'lodash-es/difference';
import { ElementRef, EventEmitter, } from "@angular/core";
import { EventsService } from "../../lib/EventsService";
import { PrettyNumberPipe } from "../../pipes/pretty-number.pipe";
var DATE_PERIOD_LIST = ['hour', 'day'];
var DATE_FILTER_LIST = ['last30day', 'all'];
var ChartFilterComponent = /** @class */ (function () {
    function ChartFilterComponent(eventsService) {
        this.eventsService = eventsService;
        this.period = 'day';
        this.filter = new Filter();
        this.dateFilterType = 'last30day';
        this.onFilterChange = new EventEmitter();
        var me = this;
        me.eventsService.on('period-change', function (period) {
            if (period === 'day') {
                me.dateFilterType = 'last30day';
            }
            else {
                me.dateFilterType = 'all';
            }
        });
    }
    ChartFilterComponent.prototype._onFilterChange = function (filter) {
        if (filter.period) {
            this.period = filter.period;
        }
        else if (filter.filter) {
            this.dateFilterType = filter.filter;
        }
        this.onFilterChange.emit({
            period: this.period,
            chartFilter: {
                type: this.dateFilterType
            }
        });
    };
    return ChartFilterComponent;
}());
export { ChartFilterComponent };
var Filter = /** @class */ (function () {
    function Filter() {
        this.datePeriodList = DATE_PERIOD_LIST;
        this.dateFilterList = DATE_FILTER_LIST;
    }
    return Filter;
}());
export { Filter };
var chartSub = new Subject();
var chartEvent = from(chartSub);
var Options = /** @class */ (function () {
    function Options() {
        this.isLoad = false;
        this.isChartFilter = false;
        this.title = '';
        this.showLabels = [];
        this.labels = {};
        this.colors = {};
        this.axis = {};
        this.grid = {};
        this.period = '';
        this.axes = {};
        this.names = {};
        this.filter = new Filter();
        this.chartType = 'line';
        this.chartValue = '';
        this.groups = [];
        this.events = {};
        this.size = { height: 320 };
        this.padding = '';
        this.legend = {};
        this.toggle = chartEvent;
        this.$toggle = chartSub;
        this.lazyRender = false;
    }
    return Options;
}());
export { Options };
var ChartParams = /** @class */ (function () {
    function ChartParams(opts) {
        this.name = '';
        this.data = {};
        this.options = new Options();
        this.filter = {};
        if (opts)
            this.setOptions(opts);
    }
    ChartParams.prototype.setOptions = function (options) {
        this.options = merge({}, this.options, options);
        if (options && options.filter && options.filter.datePeriodList) {
            this.options.filter.datePeriodList = options.filter.datePeriodList;
        }
    };
    ChartParams.prototype.getOptions = function () {
        return merge({}, this.options);
    };
    Object.defineProperty(ChartParams.prototype, "isLoader", {
        get: function () {
            return this.options.isLoad;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartParams.prototype, "title", {
        set: function (title) {
            this.options.title = title;
        },
        enumerable: true,
        configurable: true
    });
    ChartParams.prototype.showLoader = function () {
        this.options.isLoad = true;
    };
    ChartParams.prototype.hideLoader = function () {
        this.options.isLoad = false;
    };
    ChartParams.prototype.getFilterParams = function (filterParams) {
        return merge({}, filterParams, this.filter);
    };
    return ChartParams;
}());
export { ChartParams };
function downloadChartData(anchor, data, options) {
    var isCats = (options.axis ? (options.axis.x ? (options.axis.x.categories ? true : false) : false) : false);
    var titles = [];
    var rows = [];
    var kk = Object.keys(data);
    for (var _i = 0, kk_1 = kk; _i < kk_1.length; _i++) {
        var i = kk_1[_i];
        var title = data[i][0];
        if (options && options['names'] && options['names'][title]) {
            title = "\"" + options['names'][title] + "\"";
        }
        titles.push(title);
        var row = (data[i]).slice(1);
        rows.push(row);
    }
    if (isCats) {
        titles.unshift('*');
    }
    var csv = titles.join(',') + '\n';
    var _loop_1 = function (i) {
        var line = [];
        if (isCats) {
            var cat = (options.axis.x.categories[i - 1]).toString();
            cat = cat.replace(/, /g, '/');
            cat = cat.replace(/,/g, '/');
            line.push(cat);
        }
        csv += kk.reduce(function (p, c) {
            var v = data[c][i];
            if (c == '0' && isFinite(v) && v > 946674000000) {
                v = moment(v).format('DD.MM.YYYY');
            }
            p.push(v);
            return p;
        }, line).join(',') + '\n';
    };
    for (var i = 1; i < data[0].length; i++) {
        _loop_1(i);
    }
    anchor.download = 'chart_data.csv';
    anchor.href = "data:text/csv;charset=utf-8;base64," + window.btoa(unescape(encodeURIComponent(csv)));
    anchor.click();
}
var ChartComponent = /** @class */ (function () {
    function ChartComponent(prettyNumber) {
        var _this = this;
        this.prettyNumber = prettyNumber;
        this.period = 'day';
        this.flag = false;
        // TODO заменить на массив и проверить, что ничего не сломается
        this.data = {};
        this.options = new Options();
        this.name = 'chart1';
        this.onFilterChange = new EventEmitter();
        this.options.toggle.subscribe(function (label) {
            _this.toggle(label);
        });
    }
    ChartComponent.prototype.getStyle = function () {
        if (this.options.isLoad || !this.isHasData) {
            return {
                'height': this.options.size.height + "px",
                'display': 'flex',
                'background-color': '#ECF2F7'
            };
        }
        else {
            return {};
        }
    };
    ChartComponent.prototype.getChartInstance = function (data, options) {
        var me = this;
        // Преобразовать параметры в c3 конфиг
        var opts = merge({}, {
            showLabels: options.showLabels || [],
            groups: options.groups,
            size: options.size,
            padding: options.padding,
            bindto: me.line.nativeElement,
        }, {
            axis: options.axis || {},
            grid: options.grid || {},
            data: {
                names: merge({}, options.names),
                colors: merge({}, options.colors),
                axes: merge({}, options.axes),
                type: options.type,
                onclick: options.onclick
            },
            period: this.period,
            legend: options.legend || {},
            tooltip: options.tooltip || {
                format: {
                    value: function (value) {
                        return me.prettyNumber.transform(value);
                    }
                }
            },
            groups: options.groups,
            chartType: options.chartType
        });
        if (options.events && Object.keys(options.events).length > 0) {
            Object.keys(options.events).forEach(function (event) {
                opts.data[event] = options.events[event];
            });
        }
        return new Line2(data, opts, options.lazyRender);
    };
    ChartComponent.prototype.ngOnChanges = function () {
        var me = this;
        if (me.chart) {
            me.chart = me.chart.destroy();
        }
        if (me.isHasData) {
            me.chart = me.getChartInstance(me.data, me.options);
        }
    };
    ChartComponent.prototype.ngOnDestroy = function () {
        if (this.chart)
            this.chart.destroy();
    };
    ChartComponent.prototype._onFilterChange = function (filter) {
        this.onFilterChange.emit(filter);
    };
    ChartComponent.prototype.toggle = function (label) {
        this.chart.instance.toggle([label]);
    };
    ChartComponent.prototype.hideAllLabels = function () {
        this.chart.instance.hide();
    };
    ChartComponent.prototype.exportData = function () {
        try {
            downloadChartData(this.exportFile.nativeElement, this.data, this.options);
        }
        catch (err) {
            alert(err);
        }
    };
    Object.defineProperty(ChartComponent.prototype, "isHasData", {
        get: function () {
            var me = this;
            return me.data && ((Array.isArray(me.data) && me.data.length > 0) || (Object.keys(me.data).length > 0));
        },
        enumerable: true,
        configurable: true
    });
    return ChartComponent;
}());
export { ChartComponent };
var Line2 = /** @class */ (function () {
    function Line2(_data, params, lazyRender) {
        var me = this;
        me.data = merge([], _data);
        me.params = merge({
            keysMap: me.data.map(function (c) { return c[0]; }),
            period: 'day',
            filter: {
                period: 'all'
            },
            showLabels: [],
            trendLineKey: '',
            groups: []
        }, params);
        try {
            me._data = me.data;
            var weekends_1 = [];
            if (me._data && me._data.length > 0) {
                var x = me._data[0];
                x = x.slice(1)
                    .map(function (x) { return parseInt(x, 10); })
                    .sort(function (a, b) { return a - b; });
                var holidays_1 = {};
                x.forEach(function (timestamp) {
                    var date = new Date(timestamp);
                    var day = date.getDay();
                    if (day == 6 || day == 0)
                        holidays_1[date.toString()] = 1;
                });
                var holidays2 = Object.keys(holidays_1).reduce(function (arr, date) {
                    arr.push(new Date(date));
                    return arr;
                }, []);
                holidays2.forEach(function (day) {
                    weekends_1.push({
                        start: day,
                        end: new Date(day.valueOf() + 86400000)
                    });
                });
            }
            params = merge({
                regions: weekends_1,
                data: {
                    //x: 'x',
                    type: params.chartType,
                    columns: me.data
                },
                grid: {
                    x: {
                        show: true
                    },
                    y: {
                        show: true,
                        ticks: 6,
                        min: -10
                    }
                },
                legend: {
                    position: 'top'
                },
                axis: {
                    x: {
                        type: 'timeseries',
                        tick: {
                            fit: true,
                            culling: {
                                max: 16
                            },
                            //format: me.params.period === 'hour' ? '%d-%m-%Y %H:%M' : '%d-%m-%Y'
                            format: function (x) {
                                if (this.config.axis_x_type === 'timeseries') {
                                    if (me.params.period === 'hour') {
                                        return moment(x).tz('Europe/Moscow').format('DD-MM-YYYY HH:mm');
                                    }
                                    return moment(x).tz('Europe/Moscow').format('DD-MM-YYYY');
                                }
                                else {
                                    if (this.config.axis_x_categories[x]) {
                                        return this.config.axis_x_categories[x];
                                    }
                                    else {
                                        //console.warn('axis_x_categories not found');
                                        return x;
                                    }
                                }
                            }
                        }
                    },
                    y: {
                        min: 0,
                        ticks: 10,
                        padding: {
                            top: 0,
                            bottom: 10
                        }
                    }
                }
            }, params);
            if (params.axis.x.type === 'timeseries' || params.axis.x.type === 'indexed') {
                params.data.x = 'x';
            }
            if (params.data.type === 'pie') {
                params.axis = {};
                delete params.data.x;
            }
            if (params.data.type === 'bar') {
                params.axis.y.padding.bottom = 0;
            }
            if (lazyRender) {
                var lazyData_1 = [];
                params.data.columns = params.data.columns.reduce(function (p, c) {
                    if (c[0] == 'x') {
                        p.push(c);
                    }
                    else {
                        lazyData_1.push(c);
                    }
                    return p;
                }, []);
                params.data.columns.push(lazyData_1.shift());
                me.instance = c3.generate(params);
                var timerId_1 = setInterval(function () {
                    var columns = [];
                    columns.push(lazyData_1.shift());
                    if (me.instance.internal.config == null) {
                        clearInterval(timerId_1);
                        return;
                    }
                    me.instance.load({
                        columns: columns
                    });
                    if (lazyData_1.length === 0) {
                        clearInterval(timerId_1);
                    }
                }, 500);
            }
            else {
                me.instance = c3.generate(params);
            }
            if (params.groups.length) {
                me.instance.groups([
                    me.params.groups
                ]);
            }
            if (me.params.showLabels.length > 0) {
                me.instance.toggle(difference(me.data.map(function (c) { return c[0]; }), me.params.showLabels));
            }
        }
        catch (err) {
            console.error('Chart error', err);
        }
    }
    Line2.prototype.shown = function () {
        return this.instance.data.shown.apply(this, arguments);
    };
    Line2.prototype.names = function () {
        return this.instance.data.names.apply(this, arguments);
    };
    Line2.prototype.destroy = function () {
        if (this.instance) {
            this.instance.destroy.apply(this, arguments);
        }
        return this;
    };
    Line2.prototype.unload = function () {
        this.instance.unload.apply(this, arguments);
        return this;
    };
    Line2.prototype.load = function () {
        this.instance.load.apply(this, arguments);
        return this;
    };
    Line2.prototype.getLabelMap = function () {
        var me = this, data = me.params.timeline.reduce(function (keys, key) {
            if (me.data[key]) {
                Object.keys(me.data[key]).forEach(function (key) {
                    keys[key] = 1;
                });
            }
            return keys;
        }, {});
        if (me.params.trendLineKey) {
            data[me.getTrendKey()] = 1;
        }
        return data;
    };
    Line2.prototype.getTrendKey = function () {
        return this.params.trendLineKey + '_Trend';
    };
    Line2.prototype.prepareData = function () {
        var me = this, data = merge(isArray(me.data) ? [] : {}, me.data), x = ['x'], timeline = merge(isArray(me.params.timeline) ? [] : {}, me.params.timeline), columns = [];
        if (Object.keys(timeline).length == 0)
            return [];
        var timeline2 = timeline;
        timeline2 = timeline2
            .map(function (timestamp) { return parseInt(timestamp, 10); })
            .sort(function (a, b) { return a - b; });
        Object.keys(me.params.keysMap).forEach(function (key) {
            columns[key] = [];
        });
        timeline2.forEach(function (timestamp, i) {
            timestamp = parseInt(timestamp, 10);
            x.push(timestamp);
            Object.keys(columns).forEach(function (key) {
                if (data[timestamp]) {
                    columns[key][i] = (data[timestamp][key] || 0);
                }
            });
        });
        timeline = timeline2;
        var resultData = Object.keys(columns).map(function (key) {
            return [key].concat(columns[key]);
        });
        resultData.unshift(x);
        return resultData;
    };
    Line2.prototype.getTimeline = function (stats) {
        var me = this, borderTime = moment('02-25-2015', 'MM-DD-YYYY').toDate().getTime();
        if (isArray(stats)) {
            if (me.params.period == 'day' || me.params.period == 'summary') {
                return stats.reduce(function (arr, point) {
                    if (parseInt(point.timestamp, 10) >= borderTime)
                        arr.push(point.timestamp);
                    return arr;
                }, []);
            }
            else {
                return stats.map(function (point) {
                    return point.timestamp;
                });
            }
        }
        else {
            return Object.keys(stats);
        }
    };
    return Line2;
}());
export { Line2 };
